import styled from 'styled-components';

export default styled.div`
	padding-right: var(--spacing-small);
	display: flex;
	flex-direction: column;
	gap: var(--spacing-medium);
	flex: 1;
`;
